module.exports = __webpack_public_path__ + "360ab95fef6554d436addddfed59df9b.png";